enum PaymentType {
  cash = "現金",
  creditCard = "クレジット",
}

export default PaymentType;
